import { Grid, InputAdornment } from "@mui/material";
import React, { useContext, useState } from "react";
import { Button, Input, InputCheck, InputDate } from "../../../../controls";
import { action, API, controller } from "../../../../api/api";
import { AppContext } from "../../../../App";

const ReturnFields = ({
  stockDetails,
  setStockDetails,
  handleClear,
  values,
  setValues,
  handleInpChg,
  handleInpDate,
  handleInpCheck,
}) => {
  const { setLoader } = useContext(AppContext);
  const [orderNoError, setOrderNoError] = useState("");

  // Call API to find order by orderNo
  const handleFindOrder = (e) => {
    if (values.orderNo) {
      setLoader(true);
      API(controller.Stock + action.GetByOrderNo).getById(
        values.orderNo,
        (res) => {
          if (res && res.status === 200 && res.result) {
            var result = res.result;
            setStockDetails({ ...result });

            setValues((j) => ({
              ...j,
              stockId: result.id || "",
              supplierId: result.splrId || "",
            }));
          } else {
            setOrderNoError(
              "Invalid order number or Maybe this order isn't received yet."
            );
            handleClear && handleClear();
          }

          setLoader(false);
        }
      );
    } else {
      handleClear && handleClear();
      setOrderNoError("Please enter the valid order number.");
    }
  };

  const handleOrderNoChg = (e) => {
    handleInpChg(e);
    setOrderNoError("");
    setStockDetails({});
    handleClear && handleClear();
  };

  return (
    <>
      <Grid item xs={12} md={6}>
        <div className="flex flex-col gap-5">
          <Input
            label="Order No."
            name="orderNo"
            value={values.orderNo}
            error={orderNoError}
            onChange={handleOrderNoChg}
            sx={{
              "& .MuiInputBase-root": {
                paddingRight: "4px",
              },
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleFindOrder();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    onClick={handleFindOrder}
                    variant="text"
                    className="!rounded-[8px] "
                    sx={{ padding: "5px 8px" }}
                  >
                    <span className="text-[12px] font-bold uppercase ">
                      Validate
                    </span>
                  </Button>
                </InputAdornment>
              ),
            }}
          />
          <div className="flex flex-col md:flex-row gap-3">
            <InputDate
              label="Return Date"
              name="returnDate"
              value={values.returnDate}
              onChange={(date) =>
                handleInpDate("returnDate", new Date(date).toISOString())
              }
            />
            <Input
              label="Supplier"
              value={
                stockDetails.id
                  ? `${stockDetails.splrName} ${
                      stockDetails.splrCompany &&
                      " | " + stockDetails.splrCompany
                    }`
                  : ""
              }
              disabled={true}
            />
          </div>
        </div>
      </Grid>

      <Grid item xs={12} md={6}>
        <div className="flex flex-col gap-2">
          <Input
            label="Note"
            name="note"
            rows={2}
            multiline={true}
            value={values.note}
            onChange={handleInpChg}
          />
          <InputCheck
            label="Keep the return amount as credit balance."
            name="keepRefundAsCredit"
            checked={values.keepRefundAsCredit}
            onChange={handleInpCheck}
          />
        </div>
      </Grid>
    </>
  );
};

export default ReturnFields;
